import { connect } from 'react-redux';
import { 
    fetchAuthorize, 
    getLoginFetchingStatus, 
    getLoginError, 
    cleanLoginError, 
    getIs2FARequired 
} from './../../../reducers/account/login';
import Login from './Login';
import {getTranslation} from "../../../reducers/common/localization";
import {setResetPasswordEmail} from "../../../reducers/account/restoreAccount";

const mapStateToProps = state => {
    return {
        error: getLoginError(state),
        fetching: getLoginFetchingStatus(state),
        is2FARequired: getIs2FARequired(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onLogIn: (data) => {
            dispatch(fetchAuthorize(data));
        },
        onForgotPassword: (email) => dispatch(setResetPasswordEmail(email)),
        onUnmount: () => dispatch(cleanLoginError())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/accountManagement/login/Login.container.js